import { Modal } from "react-bootstrap";
import { useModemLogHooks } from "../../../utils/inventory/ModemUtils";
import { useState } from "react";
import Pagination from "../../Pagination";
import moment from "moment";
import { LOG_TYPE } from "../../../tools/audittools";

export default function ModalLogModem({ show, onClose, id }) {
  const handleClose = () => {
    onClose(false);
  };

  return (
    <Modal show={show} onHide={() => handleClose()} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Log Modem</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LogModemData id={id} />
      </Modal.Body>
    </Modal>
  );
}

function LogModemData({ id }) {
  const [filter, setFilter] = useState({ id: id, page: 1, page_size: 10 });

  const { logs, meta } = useModemLogHooks({ filter });

  const gotoPage = (page) => {
    setFilter({ ...filter, page: page });
  };

  return (
    <div>
      <div style={{ overflowX: "auto", marginBottom: "10px" }}>
        <table className="table table-sm table-striped table-hover table-bordered">
          <thead>
            <tr>
              <th>Waktu</th>
              <th>Aksi</th>
              <th>Pengubah</th>
              <th>Log</th>
              <th>Change Log</th>
            </tr>
          </thead>
          <tbody>
            {logs.length === 0 && (
              <tr>
                <td colSpan={5} className="text-center">
                  Tidak ada data
                </td>
              </tr>
            )}
            {logs.map((history, index) => (
              <tr key={index}>
                <td className="text-nowrap">
                  {moment.unix(history.createdAt).format("DD MMM YYYY - HH:mm:ss")}
                </td>
                <td>{LOG_TYPE[history.action_type] || history.action_type}</td>
                <td className="text-nowrap">{history.user?.name || "-"}</td>
                <td className="text-wrap">{history.request}</td>
                <td className="text-wrap">{history.change_log}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {meta.count > meta.page_size && (
        <Pagination
          totalpage={Math.ceil(meta.count / meta.page_size)}
          selectedpage={meta.page}
          clickpage={(page) => gotoPage(page)}
          next={() => gotoPage(meta.page + 1)}
          prev={() => gotoPage(meta.page - 1)}
        />
      )}
    </div>
  );
}
